<template>
  <itisFooter v-bind="$attrs">
    <template #logo>
      <img
        class="logo"
        src="https://qiniu-cdn.hotelux.com/logo-center-hotelux.png"
        alt=""
      />
    </template>
    <template #content>
      <div class="contact-message">
        <UIText class="contact-message-title" type="title">{{
          t("shell.footer.contact")
        }}</UIText>
        <div class="contact-message-text">
          <a class="context-email" href="mailto:hello@hotelux.com"
            >hello@hotelux.com</a
          >
        </div>
      </div>
      <div class="contact-list">
        <div class="contact-list-content">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="contact-list-item"
          >
            <a
              :href="item.url"
              :aria-label="item.label"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img :src="item.img" alt="" />
            </a>
          </div>
        </div>
      </div>
      <div class="contact-eqcode">
        <img
          src="https://qiniu-cdn.hotelux.com//uploaded/FtFaHZNUnOF-9d2keug5twcrFpCz/download.png"
        />
      </div>
    </template>

    <template #bottom>
      <div class="footer-bottom">{{ t("shell.footer.hoteluxCopyRight") }}</div>
    </template>
  </itisFooter>
</template>

<script setup lang="ts" name="Footer">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import itisFooter from "@/distributions/consumer/y/layout/components/Footer.vue";

import UIText from "../UiText/index.vue";
const { t, locale } = useI18n();
const linkList = ref([
  {
    url: "https://www.facebook.com/HoteLux.Official",
    type: "facebook",
    label: "Facebook",
    img: "https://qiniu-cdn.hotelux.com/FqKo1Yq5SvlhNdjwHy9x-yWVaHQk_19.png?imageView2/2/w/1920"
  },
  {
    url: "https://www.instagram.com/hotelux.official",
    type: "instagram",
    label: "Instagram",
    img: "https://qiniu-cdn.hotelux.com/FtxtpYNh-qGsKy9OqQ5OpGYR747n_19.png?imageView2/2/w/1920"
  },
  {
    url: "https://www.tiktok.com/@hotelux.official",
    type: "tiktok",
    label: "TikTok",
    img: "https://qiniu-cdn.hotelux.com/FsBl-l1T4GuYi3M2IBOT2op8hCBI_19.png?imageView2/2/w/1920"
  }
]);
const list = computed(() => {
  const newlinkList = linkList.value.map(item =>
    item.type === "instagram" && locale.value === "jp"
      ? { ...item, url: "https://www.instagram.com/hotelux.jp" }
      : item
  );
  return newlinkList;
});
</script>

<style lang="scss" scoped>
.contact-message {
  padding: 0 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  .company {
    color: #fff;
    font-size: 14px;
  }
  .contact-type {
    display: flex;
    column-gap: 28px;
  }
  .contact-message-title {
    font-size: 20px;
    line-height: 20px;
    color: #fff;
    // font-family: var(--y-title-font);
  }
  .contact-message-text {
    font-size: 16px;
    line-height: 16px;
    color: rgba(255, 255, 255, 0.8);
    font-family: var(--y-regular-font);
  }
}
.logo {
  width: 145px;
  height: 50px;
}
.contact-list {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  .contact-list-content {
    display: flex;
    column-gap: 22px;
  }
  .contact-list-item {
    border-radius: 50%;
    cursor: pointer;
    transition: opacity 180ms ease, transform 180ms ease;
    &:hover {
      opacity: 0.72;
      transform: translateY(-2px);
    }
  }
  img {
    width: 36px;
    height: 36px;

    box-sizing: content-box;
  }
}
.contact-eqcode {
  width: 80px;
  height: 80px;
}
.contact-eqcode img {
  width: 100%;
  height: 100%;
}
:deep() {
  .footer-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;
    padding: 18px max(60px, calc((100% - 1200px) / 2)) 0;
    margin: 0 auto 0;
  }
}
.footer {
  padding-top: 35px;
  padding-bottom: 0;
  background-color: #212223;
}
.footer-bottom {
  font-size: 12px;
  line-height: 12px;
  color: rgba(255, 255, 255, 0.5);
  padding: 36px 0 40px;
  text-align: center;
  font-family: lato;
  background-color: #212223;
  margin-bottom: 2px;
}
.context-email {
  text-decoration: underline;
  text-decoration-thickness: 0.5px;
  text-underline-offset: 3px;
  font-family: "lato";

  &:hover {
    color: #c7754d;
    text-decoration-color: #c7754d;
  }
}
</style>
